import React, { useMemo } from "react";
import { motion } from "framer-motion";
import { ArrowRight, CalendarCheck } from "lucide-react";
import { useBooking } from "../data";

export default function Availability() {
    const { availability, openBooking } = useBooking();

    const stats = useMemo(() => ([
        { label: "Nightly rate", value: availability ? `$${availability.nightly_rate}` : "$624" },
        { label: "Minimum stay", value: `${availability?.min_nights || 2} nights` },
        { label: "Sleeps up to", value: `${availability?.max_guests || 6} guests` },
        { label: "Dates reserved", value: `${availability?.blocked_dates?.length || 0} nights` },
    ]), [availability]);

    return (
        <section id="availability" className="py-24 lg:py-36 bg-[#0F2837] relative grain" data-testid="availability-section">
            <div className="max-w-5xl mx-auto px-5 lg:px-8 text-center">
                <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
                    <p className="text-xs uppercase tracking-[0.3em] text-[#C49A45] font-semibold">Availability & rates</p>
                    <h2 className="font-serif-d font-light text-4xl sm:text-5xl lg:text-6xl text-white mt-4 leading-[1.05]">
                        Your dates are <em className="text-[#E9D9AE]">waiting.</em>
                    </h2>
                    <p className="mt-6 text-white/70 max-w-xl mx-auto text-sm sm:text-base leading-relaxed">
                        Open the live calendar, pick your check-in and check-out, and reserve your spot in under a minute. Reserved nights are blocked instantly — no double bookings, no surprises.
                    </p>
                </motion.div>

                <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.15 }}
                    className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="availability-stats">
                    {stats.map((s) => (
                        <div key={s.label} className="rounded-3xl border border-white/15 bg-white/5 backdrop-blur px-6 py-7">
                            <p className="font-serif-d text-3xl text-white">{s.value}</p>
                            <p className="text-[11px] uppercase tracking-[0.2em] text-white/50 mt-2">{s.label}</p>
                        </div>
                    ))}
                </motion.div>

                <motion.button onClick={() => openBooking()} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.25 }}
                    data-testid="availability-open-calendar-button"
                    className="btn-amber-lux mt-10 inline-flex items-center gap-3 rounded-full px-10 py-5 text-sm font-bold tracking-wide">
                    <CalendarCheck size={18} /> Open the availability calendar <ArrowRight size={16} />
                </motion.button>
                <p className="mt-4 text-white/40 text-xs">Live availability · confirmed nights are held instantly</p>
            </div>
        </section>
    );
}
